export const homePrefix = '/';
export const etlPrefix = '/etl/';
export const dashboardPrefix = '/dashboard/';

type Route = {
	path: string;
	pathWithoutPrefix: string;
	label: string;
	protected: boolean;
};

export const homeRoutes: { [key: string]: Route } = {
	home: {
		path: homePrefix,
		pathWithoutPrefix: "/",
		label: "Accueil",
		protected: false,
	}
};

// L'ordre des clés définit l'ordre de navigation du tunnel (useEtlSteps)
export const etlRoutes: { [key: string]: Route } = {
	selectCompetitor: {
		path: `${etlPrefix}select-competitor`,
		pathWithoutPrefix: "select-competitor",
		label: "Sélectionner un concurrent",
		protected: true,
	},
	etlAnalyseLaboratoires: {
		path: `${etlPrefix}analyse-laboratoires`,
		pathWithoutPrefix: "analyse-laboratoires",
		label: "Analyse des laboratoires",
		protected: true,
	},
	etlUploadFiles: {
		path: `${etlPrefix}upload-files`,
		pathWithoutPrefix: "upload-files",
		label: "Téléversement des fichiers",
		protected: true,
	},
	etlUnzip: {
		path: `${etlPrefix}unzip`,
		pathWithoutPrefix: "unzip",
		label: "Désarchivage",
		protected: true,
	},
	etlPreProcess: {
		path: `${etlPrefix}pre-process`,
		pathWithoutPrefix: "pre-process",
		label: "Inspection",
		protected: true,
	},
	etlMergeCsv: {
		path: `${etlPrefix}merge-csv`,
		pathWithoutPrefix: "merge-csv",
		label: "Fusion",
		protected: true,
	},
	etlInputImport: {
		path: `${etlPrefix}input-import`,
		pathWithoutPrefix: "input-import",
		label: "Chargement des CSV",
		protected: true,
	},
	etlExtractImport: {
		path: `${etlPrefix}extract-import`,
		pathWithoutPrefix: "extract-import",
		label: "Extraction des données AW",
		protected: true,
	},
	etlDictionaryGenerate: {
		path: `${etlPrefix}dictionary-generate`,
		pathWithoutPrefix: "dictionary-generate",
		label: "Génération des dictionnaires",
		protected: true,
	},
	etlUser: {
		path: `${etlPrefix}dictionnaire-utilisateurs`,
		pathWithoutPrefix: "dictionnaire-utilisateurs",
		label: "Dictionnaire des utilisateurs",
		protected: true,
	},
	etlBrand: {
		path: `${etlPrefix}dictionnaire-marques`,
		pathWithoutPrefix: "dictionnaire-marques",
		label: "Dictionnaire des marques",
		protected: true,
	},
	etlSupplier: {
		path: `${etlPrefix}dictionnaire-fournisseurs`,
		pathWithoutPrefix: "dictionnaire-fournisseurs",
		label: "Dictionnaire des fournisseurs",
		protected: true,
	},
	etlCategory: {
		path: `${etlPrefix}dictionnaire-categories`,
		pathWithoutPrefix: "dictionnaire-categories",
		label: "Dictionnaire des catégories",
		protected: true,
	},
	etlProduct: {
		path: `${etlPrefix}dictionnaire-produits`,
		pathWithoutPrefix: "dictionnaire-produits",
		label: "Dictionnaire des produits",
		protected: true,
	},
	etlScheduleType: {
		path: `${etlPrefix}dictionnaire-types-horaires`,
		pathWithoutPrefix: "dictionnaire-types-horaires",
		label: "Dictionnaire des types d'horaires",
		protected: true,
	},
	etlOutputData: {
		path: `${etlPrefix}output-data`,
		pathWithoutPrefix: "output-data",
		label: "Génération des données d'export",
		protected: true,
	},
	etlOutputCsv: {
		path: `${etlPrefix}output-csv`,
		pathWithoutPrefix: "output-csv",
		label: "Génération des CSV d'export",
		protected: true,
	},
	uploadEtlResult: {
		path: `${etlPrefix}upload-etl-result`,
		pathWithoutPrefix: "upload-etl-result",
		label: "Upload des résultats",
		protected: true,
	},
	triggerAwInsert: {
		path: `${etlPrefix}trigger-insert`,
		pathWithoutPrefix: "trigger-insert",
		label: "Trigger d'insertion",
		protected: true,
	},
	etlAwAttributeCorrector: {
		path: `${etlPrefix}attribute-correction`,
		pathWithoutPrefix: "attribute-correction",
		label: "Correctif d'attribut",
		protected: true,
	},
	allCompleted: {
		path: `${etlPrefix}all-completed`,
		pathWithoutPrefix: "all-completed",
		label: "Toutes les étapes sont terminées",
		protected: true,
	},
};

export const dashboardRoutes: { [key: string]: Route } = {
	dashboard: {
		path: `${dashboardPrefix}`,
		pathWithoutPrefix: "",
		label: "Dashboard",
		protected: true,
	},
};
